/**
 * Custom CSS class name used with react-datepicker's `highlightDates` prop.
 * react-datepicker applies the object key as a class name to matching dates.
 * The corresponding styles live in `datepicker.style.ts`.
 */
export const HIGHLIGHT_CLASS_EXTRA_OCCURRENCE = 'extra-occurrence-selected';
